<template>
  <div>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">Generate Bulk</h4>
      </div>
      <div class="level-right">
        <router-link :to="{name: 'List Of Payrolls'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-3">
        <div class="control">
          <div class="field">
            <label class="label is-small">Branch (Code & Name)</label>
            <div class="control">
              <b-autocomplete v-model="branchName" size="is-small" :data="branches" placeholder="Search branches" @select="option => selectedBranch = option" @input="searchBranches" :loading="isFetchingBranches" v-validate="'required'" name="Branch">
                <template slot="empty">
                  <span v-if="isFetchingBranches">
                    Please wait...
                  </span>
                  <span v-if="branches.length === 0">
                    No results found
                  </span>
                </template>
              </b-autocomplete>
              <span style="font-size:12px" class="has-text-danger">{{ errors.first('Branch') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <label class="label is-small">Department</label>
        <b-select size="is-small" :disabled="isDisabledField" v-model="selectedDepartment">
          <option v-for="department in employees.departmentDetailsForBulk" :value="department.departmentId" :key="department.departmentId">
            {{ department.name }}
          </option>
        </b-select>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll Date</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="payrollDate" name="Payroll date" v-validate="'required'" :disabled="isDisabledField" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Payroll date') }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll From</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="payrollFrom" name="Payroll from" v-validate="'required'" :disabled="isDisabledField" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Payroll from') }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll To</label>
          <div class="control">
            <input type="date" class="input is-small" v-model="payrollTo" name="Payroll to" v-validate="'required'" :disabled="isDisabledField" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Payroll to') }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="control">
          <div class="field">
            <label class="label is-small">&nbsp;</label>
            <div class="control">
              <b-checkbox size="is-small" v-model="isInludeContributions" :disabled="isDisabledField">Include Contributions</b-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both"></div>
    <div class="columns">
      <div class="column">
        <button :class="buttonGenerateBulkPayroll" @click="generateBulkPayroll" :disabled="isDisabledField">Generate bulk</button>
      </div>
    </div>
    <span v-show="validationMessage != ''">
      <button class="button is-small is-text" @click="isValidationNotifActive = !isValidationNotifActive">
        <span v-if="isValidationNotifActive">Hide</span>
        <span v-else>Show</span>&nbsp;validation message</button>
      <b-notification type="is-danger" :active.sync="isValidationNotifActive" has-icon aria-close-label="Close notification" role="alert">
        <p class="subtitle">The following employee has already existing payroll using this period</p>
        {{validationMessage}}
      </b-notification>
    </span>
    <div class="columns">
      <div class="column">
        <span v-show="current != 0">
          <div class="levels">
            <div class="level-left"></div>
            <div class="level-right">
              {{current}}%
            </div>
          </div>
          <progress class="progress is-info" :value="current" max="100"></progress>
        </span>
      </div>
    </div>
    <div style="clear:both"></div>
    <br />
    <b-select v-show="employees.employeeDetailsForBulk != null" size="is-small" v-model="perPage" :disabled="!isPaginated">
      <option value="5">5 per page</option>
      <option value="10">10 per page</option>
      <option value="15">15 per page</option>
      <option value="20">20 per page</option>
      <option value="100">100 per page</option>
    </b-select>
    <b-table :data="employees.employeeDetailsForBulk" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :default-sort-direction="defaultSortDirection" :loading="isLoadingTable" default-sort="user.first_name" aria-next-label="fa-arrow-left" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
      <template slot-scope="item">
        <b-table-column field="include" class="table-column-content-is-small" label="Is include?">
          <b-switch size="is-small" v-model="item.row.isInclude" />
        </b-table-column>
        <b-table-column field="name" class="table-column-content-is-small" label="Name" sortable>
          <a :href="`#/employees/edit/${item.row.employeeId}`" target="_blank" title="View profile"><img :src="`${apiHostAndPort}api/employees/profile-image/${item.row.employeeId}`" width="40" height="40" /> &nbsp;{{item.row.name}}</a>
        </b-table-column>
        <b-table-column field="name" class="table-column-content-is-small" label="Department & Job title" sortable>
          {{item.row.departmentAndJobTitle}}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>
<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import ApiInfo from '../../_services/apiInfo'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
const signalR = require('@aspnet/signalr')

const appToast = new AppToast()
const appButton = new AppButton()

const apiInfo = new ApiInfo()

export default {
  data: () => ({
    branchName: '',
    branches: [],
    employees: {},
    isInludeContributions: false,
    payrollDate: null,
    payrollFrom: null,
    payrollTo: null,
    selectedBranch: 0,
    isFetchingBranches: false,
    apiHostAndPort: '',
    validationMessage: '',
    isValidationNotifActive: false,
    // table
    isPaginated: true,
    defaultSortDirection: 'asc',
    currentPage: 1,
    perPage: 10,
    buttonGenerateBulkPayroll: appButton.isLoadingSuccess(false),
    isLoadingTable: false,
    isDisabledField: true,
    selectedDepartment: 0,
    // signalr
    name: '',
    message: '',
    connection: '',
    messages: '',
    // bulk saving progress
    current: 0
  }),
  created() {
    apiInfo.hostAndPort().then(response => {
      this.apiHostAndPort = response
    })
  },
  mounted() {
    apiInfo.hostAndPort().then(response => {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${response}hub/main`)
        .configureLogging(signalR.LogLevel.Information)
        .build()
      this.connection.start().catch(error => {
        console.log(error)
      })

      this.connection.on(
        'ReceiveStatusOfSavingBulkPayroll',
        (current, total) => {
          this.current = Math.round(current / total * 100)
        }
      )
    })
  },
  methods: {
    defaultFieldAndTable() {
      this.isInludeContributions = false
      this.payrollDate = null
      this.payrollFrom = null
      this.payrollTo = null
      this.validationMessage = ''
      this.employees = {}

      this.buttonGenerateBulkPayroll = appButton.isLoadingSuccess(false)
      this.isFetchingBranches = false
      this.isDisabledField = true
      this.current = 0
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    searchBranches: debounce(function() {
      this.isFetchingBranches = true
      axios
        .get(`api/branches/search-by-name/${this.branchName}`)
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingBranches = false
        })
    }, 500),
    getEmployeesByBranch(branchId, departmentId) {
      this.isLoadingTable = true
      axios
        .get(
          `api/employees/employees-by-branch-and-department/${branchId}/${departmentId}`
        )
        .then(response => {
          this.employees = response.data
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isLoadingTable = false
        })
    },
    generateBulkPayroll() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validationMessage = ''
          this.buttonGenerateBulkPayroll = appButton.isLoadingSuccess(true)
          this.employees.includeContributions = this.isInludeContributions
          this.employees.payrollDate = this.payrollDate
          this.employees.payrollFrom = this.payrollFrom
          this.employees.payrollTo = this.payrollTo
          this.employees.employeeDetailsForBulkPayroll = this.employees.employeeDetailsForBulk

          axios
            .post(`api/generatebulk/payroll`, this.employees)
            .then(response => {
              const responseMessage = response.data
              if (
                responseMessage ===
                'Bulk payroll has been successfully generated'
              ) {
                appToast.success(responseMessage)
              } else {
                this.isValidationNotifActive = true
                this.validationMessage = responseMessage
              }
            })
            .catch(error => console.log(error))
            .then(() => {
              this.buttonGenerateBulkPayroll = appButton.isLoadingSuccess(false)
            })
        }
      })
    }
  },
  watch: {
    selectedBranch() {
      if (this.selectedBranch) {
        this.selectedDepartment = 0
        this.getEmployeesByBranch(
          this.selectedBranch.id,
          this.selectedDepartment
        )
      } else {
        this.defaultFieldAndTable()
      }
    },
    isLoadingTable() {
      this.isLoadingTable
        ? (this.isDisabledField = true)
        : (this.isDisabledField = false)
    },
    selectedDepartment() {
      this.getEmployeesByBranch(this.selectedBranch.id, this.selectedDepartment)
      this.current = 0
    }
  }
}
</script>